import { createFileRoute } from '@tanstack/react-router';
import { AdvisorCreateSheet } from '@/pages/advisors/create-sheet';

export const Route = createFileRoute('/admin/_layout/advisors/_layout/new')({
  component: () => <AdvisorCreateSheet />,
});
